import { Pointer } from 'lucide-react';
import React from 'react';

interface CollegeAvatarsProps {
  className?: string;
}

export function CollegeAvatars({ className = '' }: CollegeAvatarsProps) {
  // College avatars from testimonials data
  const colleges = [
    {
      name: "KIIT, Bhubaneswar",
      image: "/testimonies/subham-testimony.jpg",
      initials: "KB"
    },
    {
      name: "Lovely Professional University", 
      image: "/testimonies/tamanna-testimony.png",
      initials: "LPU"
    },
    {
      name: "Swiggy (Professional)",
      image: "/testimonies/sumon-testimony.jpeg", 
      initials: "SW"
    },
    {
      name: "Antino Labs",
      image: "/testimonies/abhishek-testimony.jpeg",
      initials: "AL"
    },
    {
      name: "Pantheon",
      image: "/testimonies/atul-testimony.jpeg",
      initials: "PD"
    }
  ];

  return (
    <div className={`text-center ${className}`}>
      {/* College Avatar Circles */}
      <div className="flex justify-center items-center mb-4">
        <div className="flex -space-x-3">
          {colleges.map((college, index) => (
            <div
              key={index}
              className="relative w-12 h-12 rounded-full border-2 border-background-light dark:border-background-dark overflow-hidden bg-gradient-to-br from-primary-light/20 to-secondary-light/20 dark:from-primary-dark/20 dark:to-secondary-dark/20"
            >
              {college.image ? (
                <img
                  src={college.image}
                  alt={college.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-xs font-bold text-primary-light dark:text-primary-dark">
                  {college.initials}
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* +10K Circle */}
        <div className="w-12 h-12 rounded-full bg-background-light dark:bg-background-dark flex items-center justify-center text-text-primary-light dark:text-primary-dark font-bold text-2xl ml-2">
        🫵🏻
        </div>
      </div>
      
      {/* Text */}
      <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
        <span className='text-text-primary-light dark:text-text-primary-dark font-semibold'>Believed</span> in MockTrail for their Success
      </p>
    </div>
  );
}